export const CITY_STATE_ZIP_TRANSLATIONS = {
    cs: {
        cityLabel: "Mesto",
        requiredErrorMessage: "Povinný údaj"
    },
    da: {
        cityLabel: "By",
        requiredErrorMessage: "Dette felt skal udfyldes."
    },
    de: {
        cityLabel: "Stadt",
        requiredErrorMessage: "Dieses Feld muss ausgefüllt werden."
    },
    en: {
        countyLabel: 'County',
        countyPlaceholder: 'County Name',
        countyErrorMessage: 'The county you have entered contains invalid characters.',
        cityLabel: 'City',
        cityPlaceholder: 'City Name',
        cityErrorMessage: 'Your city name is invalid',
        requiredErrorMessage: 'This field is required'
    },
    en_AU: {
        cityLabel: "Suburb"
    },
    en_DE: {
        cityLabel: 'Town/City'
    },
    en_ES: {
        cityLabel: 'Town/City'
    },
    en_FR: {
        cityLabel: 'Town/City'
    },
    en_GB: {
        cityLabel: 'Town/City'
    },
    en_HK: {
        cityLabel: "District"
    },
    en_HU: {
        cityLabel: 'Town/City'
    },
    en_NO: {
        cityLabel: 'Town/City'
    },
    en_NZ: {
        countyLabel: 'Suburb'
    },
    en_PE: {
        stateLabel: 'Region',
        countyLabel: 'District',
        countyPlaceholder: 'District Name',
        countyErrorMessage: 'The district you have entered contains invalid characters.'
    },
    en_VN: {
        stateLabel: 'Province',
        countyLabel: 'District',
        cityLabel: 'Ward'
    },
    en_ZA: {
        countyLabel: 'Suburb',
        countyPlaceholder: 'Suburb Name',
        cityLabel: 'City/Town',
        cityPlaceholder: 'City/Town'
    },
    es: {
        countyLabel: 'Suburbio',
        countyPlaceholder: 'Nombre del suburbio',
        countyErrorMessage: 'El suburbio que ingresó contiene caracteres no válidos.',
        cityLabel: 'Ciudad',
        cityPlaceholder: 'Nombre de la ciudad',
        cityErrorMessage: 'El nombre de tu ciudad no es válido',
        stateLabel: 'Estado',
        statePlaceholder: 'Estado',
        requiredErrorMessage: 'Este campo es obligatorio'
    },
    es_CL: {
        countyLabel: 'Comuna',
        countyPlaceholder: 'Nombre de la comuna'
    },
    es_PE: {
        countyLabel: 'Provincia',
        countyPlaceholder: 'Nombre del provincia',
        countyErrorMessage: 'El provincia que ingresó contiene caracteres no válidos.',
        cityLabel: 'Distrito',
        cityPlaceholder: 'Nombre del distrito'
    },
    fi: {
        cityLabel: "Postitoimipaikka",
        requiredErrorMessage: "Tämä kenttä on pakollinen."
    },
    fr: {
        countyLabel: "Suburb",
        cityLabel: "Ville",
        requiredErrorMessage: "Ceci est un champ obligatoire."
    },
    hu: {
        cityLabel: "Város",
        requiredErrorMessage: "E mező kitöltése kötelező."
    },
    in: {
        cityLabel: "City",
        requiredErrorMessage: "This field is required."
    },
    is: {
        cityLabel: "Bæjarfélag",
        requiredErrorMessage: "Þessa eyðu má ekki skilja eftir auða."
    },
    it: {
        cityLabel: "Luogo",
        requiredErrorMessage: "Questo è un campo obbligatorio."
    },
    it_CH: {
        requiredErrorMessage: "Questo campo è obbligatorio."
    },
    iw: {
        cityLabel: "עיר",
        requiredErrorMessage: "This field is required."
    },
    ja: {
        countyLabel: "市区町村以下：",
        countyErrorMessage: '特殊文字は使用できません',
        cityErrorMessage: '特殊文字は使用できません',
        cityLabel: "市区郡町村：",
        requiredErrorMessage: "この項目は必須です。"
    },
    ms: {
        cityLabel: "City",
        requiredErrorMessage: "This field is required."
    },
    nl: {
        cityLabel: "Plaats",
        requiredErrorMessage: "Dit veld is verplicht."
    },
    nl_NL: {
        requiredErrorMessage: "Dit is een verplicht veld."
    },
    no: {
        cityLabel: "Sted",
        requiredErrorMessage: "Dette er et obligatorisk felt."
    },
    pl: {
        cityLabel: "Miejscowosc",
        requiredErrorMessage: "To pole należy obowiązkowo wypełnić."
    },
    pt: {
        cityLabel: "Cidade",
        requiredErrorMessage: "Campo é obrigatório"
    },
    ro: {
        cityLabel: "Oras",
        requiredErrorMessage: "Acest câmp este obligatoriu."
    },
    ru: {
        cityLabel: "Город",
        requiredErrorMessage: "Это поле обязательно для заполнения."
    },
    sk: {
        cityLabel: "Mesto",
        requiredErrorMessage: "Je potrebné vyplniť toto pole."
    },
    sv: {
        cityLabel: "Stad",
        requiredErrorMessage: "Detta fält måste ifyllas."
    },
    th: {
        cityLabel: "เมือง",
        requiredErrorMessage: "กรุณากรอกข้อมูลนี้ให้ครบถ้วน"
    },
    th_SE: {
        requiredErrorMessage: "จำเป็นต้องกรอกช่องนี้"
    },
    th_TH: {
        cityLabel: "จังหวัด"
    },
    tr: {
        cityLabel: "Sehir",
        requiredErrorMessage: "Bu alanı doldurmak zorunludur."
    },
    uk: {
        cityLabel: "Місто",
        requiredErrorMessage: "Це поле є обов язковим для заповнення."
    },
    vi: {
        cityLabel: "Phường",
        countyLabel: 'Quận/Huyện',
        requiredErrorMessage: "Trường thông tin bắt buộc"
    },
    zh: {
        countyLabel: '市郊',
        countyPlaceholder: '名称',
        countyErrorMessage: '您输入的郊区包含无效字符。',
        cityLabel: '城市',
        cityPlaceholder: '城市名',
        cityErrorMessage: '您填写的城市名称无效',
        requiredErrorMessage: '这是必填栏'
    }
};
